import { render, staticRenderFns } from "./ServicesTotal.vue?vue&type=template&id=69760e8e&scoped=true&"
import script from "./ServicesTotal.vue?vue&type=script&lang=js&"
export * from "./ServicesTotal.vue?vue&type=script&lang=js&"
import style0 from "./ServicesTotal.vue?vue&type=style&index=0&id=69760e8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69760e8e",
  null
  
)

export default component.exports